import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { SnackbarSeverityType } from '../../enums';

interface FeedbackSnackbarProps {
  open: boolean;
  message: string;
  severity?: SnackbarSeverityType;
  autoHideDuration?: number;
  onClose: () => void;
}

const ToastMessage = ({
  open,
  message,
  severity = SnackbarSeverityType.success,
  autoHideDuration = 2000,
  onClose
}: FeedbackSnackbarProps) => (
  <Snackbar
    open={open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    sx={{ zIndex: 9999 }}
  >
    <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
      {message}
    </Alert>
  </Snackbar>
);

export default ToastMessage;
